(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  var DEMO_HEROES = (window.MS_DEMO_AVATARS && window.MS_DEMO_AVATARS.length)
    ? window.MS_DEMO_AVATARS
    : [];

  ready(function () {
    var root = document.querySelector('[data-ms-wizard]');
    if (!root) return;

    var openers = document.querySelectorAll('[data-open-preview]');
    var titleEl = root.querySelector('#ms-wiz-title');
    var backBtn = root.querySelector('[data-wiz-back]');
    var progressFill = root.querySelector('[data-wiz-progress-fill]');
    var coachText = root.querySelector('[data-wiz-coach-text]');
    var hasGrandmaFlow = root.getAttribute('data-has-grandma') === 'true';
    var variantId = root.getAttribute('data-variant-id');
    var coverUrl = root.getAttribute('data-cover-url') || '';
    var productHandle = (root.getAttribute('data-product-handle') || '').toLowerCase();

    function isDinoBook() {
      return productHandle === 'dinosaurios';
    }

    function dinoTemplateUrl() {
      return root.getAttribute('data-cover-template-url') ||
        'https://books-for-kids-hero.pablocamprubi.workers.dev/templates/dino-cover.png';
    }

    function coverAssetUrl(file) {
      var origin = root.getAttribute('data-cover-asset-origin') ||
        'https://books-for-kids-hero.pablocamprubi.workers.dev';
      return origin + '/templates/' + file;
    }

    function getVariantId() {
      var fromWizard = root.getAttribute('data-variant-id');
      var pdp = document.querySelector('[data-ms-pdp]');
      var fromPdp = pdp && pdp.getAttribute('data-variant-id');
      return fromPdp || fromWizard || variantId;
    }

    var state = {
      step: 'upload-child',
      childFileUrl: '',
      childFirst: '',
      childLast: '',
      childAge: '',
      childGender: 'neutral',
      heroUrl: '',
      heroIndex: 0,
      heroSeed: null,
      heroRequestId: '',
      coverUrl: '',
      coverImage: '',
      coverRequestId: '',
      coverPending: false,
      coverFailed: false,
      archiveKey: '',
      archiveId: '',
      originalPhotoUrl: '',
      grandmaArchiveKey: '',
      grandmaArchiveId: '',
      grandmaPhotoUrl: '',
      regenCount: 0,
      contactMethod: 'email',
      contactEmail: '',
      contactWhatsapp: '',
      contactSaved: false,
      editingNameFromSave: false,
      includeGrandma: false,
      grandmaFileUrl: '',
      grandmaName: '',
      history: []
    };

    var TITLES = {
      'upload-child': 'Crear personaje',
      'child-details': 'Crear personaje',
      'child-meta': 'Crear personaje',
      generating: 'Creando magia',
      'meet-hero': 'Conoce a tu héroe',
      'see-cover': 'Así se verá tu libro',
      'save-contact': 'Crear personaje',
      'add-grandma': 'Añadir a la abuela',
      'upload-grandma': "Foto de la abuela",
      'grandma-details': "Nombre de la abuela",
      'book-preview': 'Tu vista previa'
    };

    var COACH = {
      'upload-child': 'Elige tu foto favorita. Mejor de frente y nítida.',
      'child-details': 'Todo héroe necesita un nombre. ¿Cómo lo llamamos?',
      'child-meta': 'Unos datos más para que la historia parezca escrita solo para tu peque.',
      generating: 'Un momento — la magia tarda un poquito.',
      'meet-hero': '¡Queda genial! Puedes regenerar o continuar.',
      'see-cover': 'Te mostramos un ejemplo de cómo se verá el libro. El arte final lo retocan artistas.',
      'save-contact': 'Guarda a tu héroe para poder volver cuando quieras.',
      'add-grandma': '¿Quieres que la abuela salga también en la historia?',
      'upload-grandma': "Sube una foto nítida y de frente de la abuela.",
      'grandma-details': '¿Cómo la llamamos en el libro?',
      'book-preview': 'Tu vista previa personalizada está lista.'
    };

    var errorEl = root.querySelector('[data-wiz-error]');
    var errorTitle = root.querySelector('[data-wiz-error-title]');
    var errorBody = root.querySelector('[data-wiz-error-body]');
    var errorRetry = root.querySelector('[data-wiz-error-retry]');
    var photoBanner = root.querySelector('[data-photo-banner]');
    var photoBannerClose = root.querySelector('[data-photo-banner-close]');
    var photoBannerText = root.querySelector('[data-photo-banner-text]');
    var retryFn = null;
    var genTimer = null;
    var coverJob = 0;
    var photoBannerTimer = null;
    var PHOTO_BANNER_DEFAULT =
      'Para un mejor resultado, usa un JPG o PNG nítido de la cara.';
    var PHOTO_BANNER_PRIVACY =
      "Las fotos se usan solo de forma temporal para la vista previa y no se guardan en nuestros servidores.";
    var PHOTO_BANNER_SOFT =
      'La foto vale, pero una imagen más nítida (al menos 400×400) suele quedar mejor impresa.';
    var PHOTO_BANNER_HARD =
      'Elige otra foto que cumpla los consejos de abajo.';

    var PHOTO_RULES = {
      maxBytes: 10 * 1024 * 1024,
      minW: 400,
      minH: 400,
      maxW: 6000,
      maxH: 6000
    };

    var funnelStartedAt = null;
    var stepEnteredAt = null;

    function productCtx() {
      return {
        product_handle: root.getAttribute('data-product-handle') || '',
        product_title: root.getAttribute('data-product-title') || '',
        variant_id: variantId || '',
        has_grandma_flow: hasGrandmaFlow,
        wizard_step: state.step,
        include_grandma: !!state.includeGrandma,
        child_age: state.childAge || null,
        child_gender: state.childGender || null,
        has_child_name: !!state.childFirst,
        has_child_last_name: !!state.childLast,
        has_child_photo: !!state.childFileUrl,
        has_grandma_photo: !!state.grandmaFileUrl,
        has_grandma_name: !!state.grandmaName,
        hero_index: state.heroIndex,
        funnel_elapsed_ms: funnelStartedAt ? Date.now() - funnelStartedAt : null,
        step_elapsed_ms: stepEnteredAt ? Date.now() - stepEnteredAt : null
      };
    }

    function track(name, extra) {
      var props = productCtx();
      if (extra) {
        Object.keys(extra).forEach(function (k) {
          props[k] = extra[k];
        });
      }
      try {
        if (typeof window.msTrack === 'function') window.msTrack(name, props);
        else if (window.posthog && typeof window.posthog.capture === 'function') {
          window.posthog.capture(name, props);
        }
      } catch (e) {}
    }

    function fileMeta(file) {
      if (!file) return {};
      return {
        file_type: file.type || null,
        file_size_bytes: file.size || null,
        file_ext: ((file.name || '').split('.').pop() || '').toLowerCase() || null
      };
    }

    function errorText(err) {
      if (err == null) return '';
      if (typeof err === 'string') return err;
      if (typeof err === 'number' || typeof err === 'boolean') return String(err);
      var msg = err && err.message;
      if (typeof msg === 'string' && msg && msg !== '[object Object]') return msg;
      if (err && typeof err.error === 'string' && err.error) return err.error;
      if (msg && typeof msg === 'object') return errorText(msg);
      if (err && err.error && typeof err.error === 'object') return errorText(err.error);
      try {
        var serialized = JSON.stringify(err);
        if (serialized && serialized !== '{}' && serialized !== 'null') return serialized;
      } catch (e) {}
      return '';
    }

    function asHeroError(err) {
      if (err instanceof Error && err.message && err.message !== '[object Object]') return err;
      var next = new Error(errorText(err) || 'Algo ha fallado al crear el personaje. Pulsa Reintentar para regenerarlo.');
      if (err && err.retryable) next.retryable = true;
      return next;
    }

    function displayErrorBody(err) {
      var msg = errorText(err).replace(/\s+/g, ' ').trim();
      if (!msg || msg === '[object Object]' || msg.charAt(0) === '{' || msg.charAt(0) === '[') {
        return 'Algo ha fallado al crear el personaje. Pulsa Reintentar para regenerarlo.';
      }
      return msg.slice(0, 180);
    }

    function showError(opts) {
      opts = opts || {};
      var fallback = "Algo no ha cargado del todo bien. Suele arreglarse solo: pulsa Reintentar y seguimos donde lo dejamos.";
      var body = opts.body;
      if (!body || body === '[object Object]') body = fallback;
      if (errorTitle) errorTitle.textContent = opts.title || 'Ha habido un pequeño tropiezo';
      if (errorBody) errorBody.textContent = body;
      retryFn = typeof opts.retry === 'function' ? opts.retry : null;
      if (errorEl) errorEl.hidden = false;
      track('preview_error_shown', {
        error_title: opts.title || 'Ha habido un pequeño tropiezo',
        error_reason: opts.reason || null,
        error_message: (opts.error_message || body || fallback).slice(0, 240)
      });
    }

    function hideError() {
      if (errorEl) errorEl.hidden = true;
      retryFn = null;
    }

    function hidePhotoBanner() {
      if (photoBannerTimer) {
        clearTimeout(photoBannerTimer);
        photoBannerTimer = null;
      }
      if (photoBanner) {
        photoBanner.hidden = true;
        photoBanner.classList.remove('is-recommend');
      }
      if (photoBannerText) photoBannerText.textContent = PHOTO_BANNER_DEFAULT;
    }

    function setCheck(name, status) {
      if (!photoBanner) return;
      var li = photoBanner.querySelector('[data-check="' + name + '"]');
      if (!li) return;
      li.classList.remove('is-ok', 'is-bad', 'is-pending');
      li.classList.add(status === true ? 'is-ok' : status === false ? 'is-bad' : 'is-pending');
    }

    function showPhotoBanner(checks, opts) {
      opts = opts || {};
      if (!photoBanner) return;
      setCheck('format', checks.format);
      setCheck('minRes', checks.minRes);
      setCheck('maxSize', checks.maxSize);
      setCheck('maxRes', checks.maxRes);

      var softWarn = !!checks.canProceed && !checks.ok;
      var hardFail = checks.canProceed === false;
      photoBanner.classList.toggle('is-recommend', softWarn);
      if (photoBannerText) {
        if (hardFail) photoBannerText.textContent = PHOTO_BANNER_HARD;
        else if (softWarn) photoBannerText.textContent = PHOTO_BANNER_SOFT;
        else if (checks.ok) photoBannerText.textContent = PHOTO_BANNER_PRIVACY;
        else photoBannerText.textContent = PHOTO_BANNER_DEFAULT;
      }

      photoBanner.hidden = false;
      if (photoBannerTimer) clearTimeout(photoBannerTimer);

      // Auto-hide when usable (full pass or soft recommendation); keep visible on hard fail
      var hideAfter = opts.autoHide;
      if (hideAfter == null) {
        if (checks.ok) hideAfter = 2200;
        else if (softWarn) hideAfter = 4500;
        else hideAfter = 0;
      }
      if (hideAfter && (checks.ok || softWarn || opts.forceAutoHide)) {
        photoBannerTimer = setTimeout(function () {
          hidePhotoBanner();
        }, hideAfter);
      }
    }

    function guessIsJpegOrPng(file) {
      var t = ((file && file.type) || '').toLowerCase();
      if (t === 'image/jpeg' || t === 'image/jpg' || t === 'image/pjpeg' || t === 'image/png') return true;
      var name = ((file && file.name) || '').toLowerCase();
      if (/\.(jpe?g|png)$/.test(name)) return true;
      return false;
    }

    function inspectImage(file) {
      return new Promise(function (resolve) {
        if (!file) {
          resolve({ format: false, maxSize: false, minRes: false, maxRes: false, ok: false, width: 0, height: 0, loadable: false });
          return;
        }

        var formatOk = guessIsJpegOrPng(file);
        var sizeOk = file.size <= PHOTO_RULES.maxBytes;
        var t = (file.type || '').toLowerCase();
        var looksLikeImage = formatOk || t.indexOf('image/') === 0 || !t;

        if (!looksLikeImage) {
          resolve({ format: false, maxSize: sizeOk, minRes: false, maxRes: false, ok: false, width: 0, height: 0, loadable: false });
          return;
        }

        var url = URL.createObjectURL(file);
        var img = new Image();
        var settled = false;
        function finish(result) {
          if (settled) return;
          settled = true;
          try { URL.revokeObjectURL(url); } catch (e) {}
          resolve(result);
        }

        img.onload = function () {
          var w = img.naturalWidth || img.width || 0;
          var h = img.naturalHeight || img.height || 0;
          var minRes = w >= PHOTO_RULES.minW && h >= PHOTO_RULES.minH;
          var maxRes = w > 0 && h > 0 && w <= PHOTO_RULES.maxW && h <= PHOTO_RULES.maxH;
          // If the browser decoded it, treat format as acceptable for proceeding
          var formatPass = formatOk || (w > 0 && h > 0);
          finish({
            format: formatPass,
            maxSize: sizeOk,
            minRes: minRes,
            maxRes: maxRes,
            ok: formatPass && sizeOk && minRes && maxRes,
            // Allow forward whenever we can decode a usable photo under max size
            canProceed: sizeOk && w > 0 && h > 0,
            width: w,
            height: h,
            loadable: true
          });
        };
        img.onerror = function () {
          finish({
            format: formatOk,
            maxSize: sizeOk,
            minRes: false,
            maxRes: false,
            ok: false,
            canProceed: false,
            width: 0,
            height: 0,
            loadable: false
          });
        };
        // Safety: never hang the UI if decode stalls
        setTimeout(function () {
          finish({
            format: formatOk,
            maxSize: sizeOk,
            minRes: false,
            maxRes: false,
            ok: false,
            canProceed: false,
            width: 0,
            height: 0,
            loadable: false,
            timedOut: true
          });
        }, 8000);
        img.src = url;
      });
    }

    function handlePhotoSelect(file, kind) {
      hideError();
      if (!file) return;

      track('preview_photo_selected', Object.assign({ photo_kind: kind }, fileMeta(file)));
      showPhotoBanner({ format: null, minRes: null, maxSize: null, maxRes: null, ok: false });

      inspectImage(file)
        .then(function (checks) {
          showPhotoBanner(checks);

          track('preview_photo_validated', Object.assign({
            photo_kind: kind,
            format_ok: !!checks.format,
            size_ok: !!checks.maxSize,
            min_res_ok: !!checks.minRes,
            max_res_ok: !!checks.maxRes,
            can_proceed: !!checks.canProceed,
            fully_ok: !!checks.ok,
            width: checks.width || 0,
            height: checks.height || 0,
            loadable: !!checks.loadable,
            timed_out: !!checks.timedOut
          }, fileMeta(file)));

          // Soft-block only when file can't be used at all
          if (!checks.canProceed) {
            track('preview_photo_rejected', Object.assign({
              photo_kind: kind,
              width: checks.width || 0,
              height: checks.height || 0,
              timed_out: !!checks.timedOut
            }, fileMeta(file)));
            if (kind === 'child') go('upload-child', { replace: true });
            else go('upload-grandma', { replace: true });
            return;
          }

          var url;
          try {
            url = URL.createObjectURL(file);
          } catch (err) {
            showError({
              reason: 'photo_blob_failed',
              retry: function () {
                hideError();
              }
            });
            return;
          }

          if (kind === 'child') {
            if (state.childFileUrl && state.childFileUrl.indexOf('blob:') === 0) {
              try { URL.revokeObjectURL(state.childFileUrl); } catch (e) {}
            }
            state.childFileUrl = url;
            if (!state.archiveKey) state.archiveKey = newArchiveKey();
            track('preview_photo_accepted', Object.assign({ photo_kind: 'child', width: checks.width, height: checks.height }, fileMeta(file)));
            archivePreview({ kind: 'child', status: 'preview' });
            // Never carry the tip onto the details form
            hidePhotoBanner();
            go('child-details');
          } else {
            if (state.grandmaFileUrl && state.grandmaFileUrl.indexOf('blob:') === 0) {
              try { URL.revokeObjectURL(state.grandmaFileUrl); } catch (e) {}
            }
            state.grandmaFileUrl = url;
            if (!state.grandmaArchiveKey) state.grandmaArchiveKey = newArchiveKey();
            track('preview_photo_accepted', Object.assign({ photo_kind: 'grandma', width: checks.width, height: checks.height }, fileMeta(file)));
            archivePreview({ kind: 'grandma', status: 'preview', archiveKey: state.grandmaArchiveKey });
            hidePhotoBanner();
            go('grandma-details');
          }
        })
        .catch(function () {
          track('preview_photo_read_failed', Object.assign({ photo_kind: kind }, fileMeta(file)));
          showError({
            reason: 'photo_read_failed',
            body: 'No hemos podido leer esa foto. Prueba con otro JPG o PNG.',
            retry: function () {
              hideError();
            }
          });
        });
    }

    function open(source) {
      hideError();
      hidePhotoBanner();
      funnelStartedAt = Date.now();
      stepEnteredAt = Date.now();
      root.hidden = false;
      document.body.classList.add('ms-wiz-open');
      track('preview_funnel_opened', { source: source || 'unknown' });
      go('upload-child', { replace: true });
    }

    function close(reason) {
      track('preview_funnel_closed', {
        close_reason: reason || 'user',
        completed_preview: state.step === 'book-preview'
      });
      hideError();
      hidePhotoBanner();
      if (genTimer) {
        clearInterval(genTimer);
        genTimer = null;
      }
      root.hidden = true;
      document.body.classList.remove('ms-wiz-open');
      revokeUrls();
      funnelStartedAt = null;
      stepEnteredAt = null;
    }

    function revokeUrls() {
      if (state.childFileUrl && state.childFileUrl.indexOf('blob:') === 0) {
        try { URL.revokeObjectURL(state.childFileUrl); } catch (e) {}
      }
      if (state.grandmaFileUrl && state.grandmaFileUrl.indexOf('blob:') === 0) {
        try { URL.revokeObjectURL(state.grandmaFileUrl); } catch (e) {}
      }
    }

    function readFile(file, cb, onError) {
      if (!file) {
        if (onError) onError('missing');
        return;
      }
      if (!file.type || file.type.indexOf('image/') !== 0) {
        showError({
          title: 'Ha habido un pequeño tropiezo',
          body: 'Ese archivo no parece una foto. Elige un JPG o PNG e inténtalo de nuevo.',
          retry: function () {
            hideError();
          }
        });
        return;
      }
      try {
        var url = URL.createObjectURL(file);
        cb(url);
      } catch (err) {
        showError({
          retry: onError || function () { hideError(); }
        });
      }
    }

    function setProgress() {
      if (!progressFill) return;
      var map = hasGrandmaFlow
        ? {
            'upload-child': 10,
            'child-details': 20,
            'child-meta': 30,
            generating: 40,
            'meet-hero': 50,
            'see-cover': 52,
            'save-contact': 60,
            'add-grandma': 70,
            'upload-grandma': 80,
            'grandma-details': 90,
            'book-preview': 100
          }
        : {
            'upload-child': 14,
            'child-details': 28,
            'child-meta': 42,
            generating: 56,
            'meet-hero': 70,
            'see-cover': 72,
            'save-contact': 85,
            'book-preview': 100
          };
      var pct = map[state.step] != null ? map[state.step] : 14;
      progressFill.style.width = pct + '%';
    }

    function go(step, opts) {
      opts = opts || {};
      hideError();
      var fromStep = state.step;
      if (!opts.replace && state.step && state.step !== step) {
        state.history.push(state.step);
      }
      if (opts.replace) state.history = [];
      state.step = step;
      stepEnteredAt = Date.now();

      root.querySelectorAll('[data-step]').forEach(function (el) {
        var on = el.getAttribute('data-step') === step;
        el.hidden = !on;
        el.classList.toggle('is-active', on);
      });

      if (titleEl) titleEl.textContent = TITLES[step] || 'Vista previa';
      if (coachText) {
        if (step === 'meet-hero' && state.childFirst) {
          coachText.textContent = 'Esta es la foto de ' + state.childFirst + ' y su versión ilustrada. Puedes regenerar cuando quieras.';
        } else if (step === 'see-cover' && state.childFirst) {
          coachText.textContent =
            'Te mostramos un ejemplo de cómo se verá el libro para ' + state.childFirst + '.';
        } else if (step === 'save-contact' && state.childFirst) {
          coachText.textContent = 'Guarda a ' + state.childFirst + ' para poder volver cuando quieras.';
        } else if (step === 'child-details') {
          updateNameCoach();
        } else {
          coachText.textContent = COACH[step] || '';
        }
      }
      if (backBtn) {
        var hideBack = step === 'upload-child' || step === 'generating';
        backBtn.hidden = hideBack;
      }

      // Photo tip only belongs on upload steps — never overlay later forms
      if (step !== 'upload-child' && step !== 'upload-grandma') {
        hidePhotoBanner();
      }

      setProgress();
      renderStep();

      if (fromStep !== step || opts.replace) {
        track('preview_step_viewed', {
          from_step: fromStep,
          to_step: step,
          replaced: !!opts.replace,
          step_title: TITLES[step] || step
        });
      }
    }

    function pickHero() {
      // Prefer AI hero, then uploaded photo, then demo avatars
      if (state.heroUrl) return state.heroUrl;
      if (state.childFileUrl && state.heroIndex === 0) return state.childFileUrl;
      return DEMO_HEROES[state.heroIndex % DEMO_HEROES.length];
    }

    function getHeroApiUrl() {
      var fromDom = root.getAttribute('data-hero-api-url') || '';
      var fromCfg = (window.MS_HERO_CONFIG && window.MS_HERO_CONFIG.apiUrl) || '';
      return String(fromDom || fromCfg || '').replace(/\/$/, '');
    }

    function newArchiveKey() {
      return 'fp-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    }

    function heroHeaders() {
      var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      var secret = (window.MS_HERO_CONFIG && window.MS_HERO_CONFIG.secret) || '';
      if (secret) headers['X-Hero-Secret'] = secret;
      return headers;
    }

    function sessionId() {
      try {
        if (window.posthog && typeof window.posthog.get_session_id === 'function') {
          return window.posthog.get_session_id() || '';
        }
      } catch (e) {}
      return '';
    }

    function archivePreview(opts) {
      opts = opts || {};
      var apiUrl = getHeroApiUrl();
      if (!apiUrl) return Promise.resolve(null);
      var kind = opts.kind || 'child';
      var key;
      if (opts.archiveKey) {
        key = opts.archiveKey;
      } else if (kind === 'grandma') {
        if (!state.grandmaArchiveKey) state.grandmaArchiveKey = newArchiveKey();
        key = state.grandmaArchiveKey;
      } else {
        if (!state.archiveKey) state.archiveKey = newArchiveKey();
        key = state.archiveKey;
      }

      var photoPromise;
      if (opts.imageDataUrl) {
        photoPromise = Promise.resolve(opts.imageDataUrl);
      } else if (opts.skipPhoto) {
        photoPromise = Promise.resolve(null);
      } else if (kind === 'grandma' && state.grandmaFileUrl) {
        photoPromise = sourceBlobFromUrl(state.grandmaFileUrl).then(function (blob) {
          return blobToDataUrl(blob, 1600);
        });
      } else if (state.childFileUrl) {
        photoPromise = sourceBlobFromUrl(state.childFileUrl).then(function (blob) {
          return blobToDataUrl(blob, 1600);
        });
      } else {
        photoPromise = Promise.resolve(null);
      }

      return photoPromise
        .then(function (imageDataUrl) {
          var payload = {
            archiveKey: key,
            kind: kind,
            childName: [state.childFirst, state.childLast].filter(Boolean).join(' '),
            childAge: state.childAge || '',
            childGender: state.childGender || '',
            productHandle: root.getAttribute('data-product-handle') || '',
            email: state.contactEmail || '',
            sessionId: sessionId(),
            status: opts.status || 'preview',
            heroUrl: opts.heroUrl || undefined,
            falRequestId: opts.falRequestId || state.heroRequestId || undefined,
            requestId: opts.falRequestId || state.heroRequestId || undefined
          };
          if (imageDataUrl) payload.imageDataUrl = imageDataUrl;
          return fetch(apiUrl + '/archive-preview', {
            method: 'POST',
            headers: heroHeaders(),
            body: JSON.stringify(payload),
            keepalive: true
          }).then(function (r) {
            return r.json().catch(function () { return {}; });
          });
        })
        .then(function (data) {
          if (kind === 'grandma') {
            if (data && data.archiveId) state.grandmaArchiveId = data.archiveId;
            if (data && data.originalUrl) state.grandmaPhotoUrl = data.originalUrl;
            return data;
          }
          if (data && data.archiveId) state.archiveId = data.archiveId;
          if (data && data.originalUrl) state.originalPhotoUrl = data.originalUrl;
          return data;
        })
        .catch(function () {
          return null;
        });
    }

    function blobToDataUrl(blob, maxEdge) {
      maxEdge = maxEdge || 1024;
      return new Promise(function (resolve, reject) {
        if (!blob) {
          reject(new Error('missing image'));
          return;
        }
        var url = URL.createObjectURL(blob);
        var img = new Image();
        img.onload = function () {
          try {
            var w = img.naturalWidth || img.width || 1;
            var h = img.naturalHeight || img.height || 1;
            var scale = Math.min(1, maxEdge / Math.max(w, h));
            var cw = Math.max(1, Math.round(w * scale));
            var ch = Math.max(1, Math.round(h * scale));
            var canvas = document.createElement('canvas');
            canvas.width = cw;
            canvas.height = ch;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, cw, ch);
            var dataUrl = canvas.toDataURL('image/jpeg', 0.88);
            URL.revokeObjectURL(url);
            resolve(dataUrl);
          } catch (err) {
            try { URL.revokeObjectURL(url); } catch (e) {}
            reject(err);
          }
        };
        img.onerror = function () {
          try { URL.revokeObjectURL(url); } catch (e) {}
          reject(new Error('No hemos podido leer la foto'));
        };
        img.src = url;
      });
    }

    function sourceBlobFromUrl(objectUrl) {
      return fetch(objectUrl).then(function (r) {
        if (!r.ok) throw new Error('No hemos podido leer la foto');
        return r.blob();
      });
    }

    // fal can reject a queued job on a stale account lock, which is transient and
    // invisible to the user, so one silent resubmit beats showing an error.
    function generateHeroWithFlux(opts) {
      return submitHeroJob(opts).catch(function (err) {
        if (!err || !err.retryable) throw asHeroError(err);
        return submitHeroJob(opts);
      });
    }

    function submitHeroJob(opts) {
      opts = opts || {};
      var apiUrl = getHeroApiUrl();
      if (!apiUrl) {
        return Promise.reject(new Error('La API del héroe no está configurada'));
      }
      if (!state.childFileUrl) {
        return Promise.reject(new Error('Falta la foto del peque'));
      }

      var isCover = (opts.mode || 'portrait') === 'cover';
      // Cover only needs the Pixar face URL. Re-reading the original photo here
      // delayed the job until after "Queda genial" felt slow.
      var sourcePromise = isCover && opts.faceUrl
        ? Promise.resolve(null)
        : sourceBlobFromUrl(state.childFileUrl).then(function (blob) {
            return blobToDataUrl(blob, opts.maxEdge || (isCover ? 512 : 1024));
          });

      return sourcePromise
        .then(function (imageDataUrl) {
          var payload = {
            imageDataUrl: isCover ? undefined : imageDataUrl,
            photoDataUrl: isCover ? imageDataUrl : undefined,
            faceUrl: opts.faceUrl || undefined,
            childAge: state.childAge || '',
            childGender: state.childGender || 'neutral',
            kind: opts.kind || 'child',
            mode: opts.mode || 'portrait',
            seed: opts.seed,
            productHandle: root.getAttribute('data-product-handle') || '',
            archiveKey: state.archiveKey || (state.archiveKey = newArchiveKey()),
            childName: [state.childFirst, state.childLast].filter(Boolean).join(' '),
            email: state.contactEmail || '',
            sessionId: sessionId()
          };

          return fetch(apiUrl + '/generate-hero', {
            method: 'POST',
            headers: heroHeaders(),
            body: JSON.stringify(payload)
          }).then(function (r) {
            return r.json().then(function (data) {
              if (!r.ok) {
                throw asHeroError({
                  message: (data && (data.message || data.error)) || 'No se ha podido generar el personaje',
                  retryable: !!(data && data.retryable)
                });
              }
              return data;
            });
          });
        })
        .then(function (start) {
          if (!start || !start.requestId) {
            throw new Error('No se ha recibido el identificador de generación');
          }
          if ((opts.mode || 'portrait') === 'cover') {
            state.coverRequestId = start.requestId;
            state.coverFalModel = start.falModel || 'cover';
          } else {
            state.heroRequestId = start.requestId;
            state.heroSeed = start.seed != null ? start.seed : null;
            if (start.archiveKey) state.archiveKey = start.archiveKey;
          }
          // The cover editor answers in ~20s, so 70s is already a clear failure
          // and the user should not sit through two minutes of spinner.
          return pollHeroStatus(apiUrl, start.requestId, opts.mode === 'cover' ? 35 : 40, {
            archive: (opts.mode || 'portrait') !== 'cover',
            falModel: start.falModelId || start.falModel || (opts.mode === 'cover' ? 'cover' : 'portrait')
          });
        });
    }

    function pollHeroStatus(apiUrl, requestId, maxAttempts, opts) {
      maxAttempts = maxAttempts || 90;
      opts = opts || {};
      var attempt = 0;
      var doArchive = opts.archive !== false;

      function once() {
        attempt += 1;

        return fetch(
          apiUrl + '/generate-hero/status?requestId=' + encodeURIComponent(requestId) +
            (doArchive && state.archiveKey ? '&archiveKey=' + encodeURIComponent(state.archiveKey) : '') +
            (opts.falModel ? '&model=' + encodeURIComponent(opts.falModel) : ''),
          { headers: { Accept: 'application/json' } }
        )
          .then(function (r) {
            return r.json().then(function (data) {
              if (!r.ok) {
                throw asHeroError({
                  message: (data && (data.message || data.error)) || 'Error al consultar el estado',
                  retryable: !!(data && data.retryable)
                });
              }
              return data;
            });
          })
          .then(function (data) {
            var st = (data.status || '').toLowerCase();
            if (st === 'completed') {
              if (!data.heroUrl) throw new Error('No se ha recibido la imagen del héroe');
              if (doArchive) {
                archivePreview({
                  skipPhoto: true,
                  heroUrl: data.heroUrl,
                  falRequestId: data.requestId || requestId,
                  status: 'generated'
                });
              }
              return data;
            }
            if (st === 'failed') {
              var err = asHeroError({
                message: data.error || 'No se ha podido generar el personaje',
                retryable: !!data.retryable
              });
              throw err;
            }
            if (attempt >= maxAttempts) {
              throw new Error('La generación ha tardado demasiado — inténtalo de nuevo');
            }
            return new Promise(function (resolve) {
              setTimeout(function () {
                resolve(once());
              }, 2000);
            });
          });
      }

      return once();
    }

    function startGeneratingTitles(titleNode, subNode) {
      var name = state.childFirst || 'tu héroe';
      var titles = [
        'Creando a tu héroe…',
        'Capturando la mirada y la sonrisa…',
        'Pintando magia con calidad Pixar…',
        'Ya casi está…'
      ];
      if (subNode) {
        subNode.textContent = isDinoBook()
          ? 'Primero el personaje de ' + name + ' y después su portada.'
          : 'Convirtiendo esa foto en magia con calidad Pixar.';
      }
      var i = 0;
      if (genTimer) clearInterval(genTimer);
      if (titleNode) titleNode.textContent = titles[0];
      genTimer = setInterval(function () {
        i += 1;
        if (titleNode && titles[i]) titleNode.textContent = titles[i];
        if (i >= titles.length - 1) {
          clearInterval(genTimer);
          genTimer = null;
        }
      }, 2200);
    }

    function loadCrossOriginImage(src) {
      return new Promise(function (resolve, reject) {
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () {
          resolve(img);
        };
        img.onerror = function () {
          reject(new Error('image_load_failed'));
        };
        img.src = src;
      });
    }

    // Below this the repaint is jpeg noise, above it it is the new head.
    var COVER_DIFF_LO = 12;
    var COVER_DIFF_HI = 34;
    // The editor always paints the head brighter and flatter than the artwork,
    // so we pull it back towards the template. Matching it fully would drag a
    // blond child down to the template brunette's values, hence the partial pull.
    var COVER_LUMA_PULL = 0.5;
    var COVER_SAT_PULL = 0.6;

    function imageDataOf(img, w, h) {
      var c = document.createElement('canvas');
      c.width = w;
      c.height = h;
      var ctx = c.getContext('2d');
      ctx.drawImage(img, 0, 0, w, h);
      return ctx.getImageData(0, 0, w, h).data;
    }

    function blurGray(values, w, h, radius) {
      var c = document.createElement('canvas');
      c.width = w;
      c.height = h;
      var ctx = c.getContext('2d');
      var id = ctx.createImageData(w, h);
      for (var i = 0, p = 0; i < values.length; i += 1, p += 4) {
        id.data[p] = id.data[p + 1] = id.data[p + 2] = values[i];
        id.data[p + 3] = 255;
      }
      ctx.putImageData(id, 0, 0);

      var out = document.createElement('canvas');
      out.width = w;
      out.height = h;
      var octx = out.getContext('2d');
      octx.filter = 'blur(' + radius + 'px)';
      octx.drawImage(c, 0, 0);

      var read = octx.getImageData(0, 0, w, h).data;
      var res = new Float32Array(w * h);
      for (var j = 0, q = 0; j < res.length; j += 1, q += 4) res[j] = read[q];
      return res;
    }

    function lumaOf(r, g, b) {
      return 0.299 * r + 0.587 * g + 0.114 * b;
    }

    function satOf(r, g, b) {
      var mx = Math.max(r, g, b);
      var mn = Math.min(r, g, b);
      return mx > 0 ? (mx - mn) / mx : 0;
    }

    // Fal repaints the whole canvas even though only the head changes, so we keep
    // the pristine cover and blend back exactly the pixels it altered. A fixed
    // ellipse would show its own outline whenever the new hair does not fill it.
    function composeCover(generatedUrl) {
      return Promise.all([
        loadCrossOriginImage(coverAssetUrl('dino-cover-base.jpg')),
        loadCrossOriginImage(coverAssetUrl('dino-cover-alpha.png')),
        loadCrossOriginImage(generatedUrl)
      ]).then(function (imgs) {
        var base = imgs[0];
        var ellipse = imgs[1];
        var generated = imgs[2];
        var w = base.naturalWidth || base.width;
        var h = base.naturalHeight || base.height;
        var n = w * h;

        var baseData = imageDataOf(base, w, h);
        var genData = imageDataOf(generated, w, h);
        var ellipseData = imageDataOf(ellipse, w, h);

        var diff = new Float32Array(n);
        var ell = new Float32Array(n);
        for (var i = 0, p = 0; i < n; i += 1, p += 4) {
          diff[i] =
            (Math.abs(genData[p] - baseData[p]) +
              Math.abs(genData[p + 1] - baseData[p + 1]) +
              Math.abs(genData[p + 2] - baseData[p + 2])) / 3;
          ell[i] = ellipseData[p + 3];
        }

        var diffBlur = blurGray(diff, w, h, 6);
        // Widened so the mask can follow hair that overflows the original ellipse,
        // while still refusing changes elsewhere on the cover.
        var ellBlur = blurGray(ell, w, h, 8);

        var raw = new Float32Array(n);
        for (var k = 0; k < n; k += 1) {
          var t = (diffBlur[k] - COVER_DIFF_LO) / (COVER_DIFF_HI - COVER_DIFF_LO);
          t = t < 0 ? 0 : t > 1 ? 1 : t;
          raw[k] = t * Math.min(1, (ellBlur[k] / 255) * 4) * 255;
        }
        var mask = blurGray(raw, w, h, 3);

        var count = 0;
        var baseLuma = 0;
        var baseSat = 0;
        var genLuma = 0;
        var genSat = 0;
        for (var s = 0, sp = 0; s < n; s += 1, sp += 4) {
          if (mask[s] <= 128) continue;
          count += 1;
          baseLuma += lumaOf(baseData[sp], baseData[sp + 1], baseData[sp + 2]);
          baseSat += satOf(baseData[sp], baseData[sp + 1], baseData[sp + 2]);
          genLuma += lumaOf(genData[sp], genData[sp + 1], genData[sp + 2]);
          genSat += satOf(genData[sp], genData[sp + 1], genData[sp + 2]);
        }

        var gain = 1;
        var satScale = 1;
        if (count > 1000) {
          baseLuma /= count;
          baseSat /= count;
          genLuma /= count;
          genSat /= count;
          gain = (baseLuma + (1 - COVER_LUMA_PULL) * (genLuma - baseLuma)) / Math.max(genLuma, 1);
          gain = Math.min(1.2, Math.max(0.5, gain));
          var targetSat = genSat + COVER_SAT_PULL * (baseSat - genSat);
          satScale = Math.min(2, Math.max(1, targetSat / Math.max(genSat, 0.001)));
        }

        var out = document.createElement('canvas');
        out.width = w;
        out.height = h;
        var outCtx = out.getContext('2d');
        var result = outCtx.createImageData(w, h);
        for (var m = 0, mp = 0; m < n; m += 1, mp += 4) {
          var a = mask[m] / 255;
          if (a <= 0) {
            result.data[mp] = baseData[mp];
            result.data[mp + 1] = baseData[mp + 1];
            result.data[mp + 2] = baseData[mp + 2];
            result.data[mp + 3] = 255;
            continue;
          }
          var r = genData[mp] * gain;
          var g = genData[mp + 1] * gain;
          var b = genData[mp + 2] * gain;
          var y = lumaOf(r, g, b);
          r = y + (r - y) * satScale;
          g = y + (g - y) * satScale;
          b = y + (b - y) * satScale;
          result.data[mp] = baseData[mp] * (1 - a) + Math.min(255, Math.max(0, r)) * a;
          result.data[mp + 1] = baseData[mp + 1] * (1 - a) + Math.min(255, Math.max(0, g)) * a;
          result.data[mp + 2] = baseData[mp + 2] * (1 - a) + Math.min(255, Math.max(0, b)) * a;
          result.data[mp + 3] = 255;
        }
        outCtx.putImageData(result, 0, 0);
        return out.toDataURL('image/jpeg', 0.92);
      });
    }

    // Paints the child's Pixar face onto the fixed dinosaur cover.
    // Runs in the background while the user looks at the hero comparison.
    function startCoverJob() {
      var job = (coverJob += 1);
      state.coverPending = true;
      state.coverFailed = false;
      state.coverUrl = '';
      state.coverImage = '';
      if (state.step === 'see-cover') renderCoverPreview();

      generateHeroWithFlux({
        kind: 'child',
        mode: 'cover',
        faceUrl: state.heroUrl || undefined
      })
        .then(function (cover) {
          if (job !== coverJob) return null;
          if (!cover || !cover.heroUrl) throw new Error('cover_missing');
          state.coverUrl = cover.heroUrl;
          state.coverImage = cover.heroUrl;
          state.coverRequestId = cover.requestId || '';
          state.coverPending = false;
          state.coverFailed = false;
          return null;
        })
        .catch(function () {
          if (job !== coverJob) return;
          state.coverPending = false;
          state.coverFailed = true;
        })
        .then(function () {
          if (job === coverJob && state.step === 'see-cover') renderCoverPreview();
        });
    }

    function runGenerating(thenStep) {
      track('preview_generating_started', {
        next_step: thenStep || 'meet-hero',
        child_age: state.childAge || null,
        child_gender: state.childGender || null,
        has_hero_api: !!getHeroApiUrl(),
        generate_cover: isDinoBook()
      });
      go('generating');
      var genStarted = Date.now();
      var titleNode = root.querySelector('[data-gen-title]');
      var subNode = root.querySelector('[data-gen-sub]');
      startGeneratingTitles(titleNode, subNode);

      var apiUrl = getHeroApiUrl();
      var work;

      if (apiUrl) {
        work = generateHeroWithFlux({ kind: 'child' }).then(function (data) {
          if (!data || !data.heroUrl) throw new Error('No se ha recibido la imagen del héroe');
          state.heroUrl = data.heroUrl;
          state.heroSeed = data.seed != null ? data.seed : null;
          state.heroRequestId = data.requestId || '';
          state.heroIndex = 0;
          // Kick the cover off the moment the face exists, while the user is
          // still looking at "Queda genial". Do not wait for that click.
          if (isDinoBook()) startCoverJob();
          return data;
        });
      } else {
        work = new Promise(function (resolve) {
          setTimeout(function () {
            state.heroIndex = 0;
            state.heroUrl = state.childFileUrl || pickHero();
            resolve({ heroUrl: state.heroUrl, fallback: true });
          }, 2100);
        });
      }

      work
        .then(function (data) {
          if (genTimer) {
            clearInterval(genTimer);
            genTimer = null;
          }
          var next = thenStep || 'meet-hero';
          if (isDinoBook() && !apiUrl) {
            state.coverUrl = dinoTemplateUrl();
            state.coverImage = state.coverUrl;
            state.coverPending = false;
            state.coverFailed = false;
          }
          track('preview_generating_completed', {
            duration_ms: Date.now() - genStarted,
            next_step: next,
            used_flux: !(data && data.fallback),
            used_uploaded_photo: !!(data && data.fallback),
            hero_seed: state.heroSeed,
            has_cover: !!state.coverUrl
          });
          go(next);
        })
        .catch(function (err) {
          if (genTimer) {
            clearInterval(genTimer);
            genTimer = null;
          }
          track('preview_generating_failed', {
            duration_ms: Date.now() - genStarted,
            error_message: (errorText(err) || 'unknown').slice(0, 240)
          });
          go('child-meta', { replace: true });
          showError({
            reason: 'generating_failed',
            title: 'No hemos podido crear a tu héroe',
            body: displayErrorBody(err),
            error_message: (errorText(err) || 'unknown').slice(0, 240),
            retry: function () {
              hideError();
              runGenerating(thenStep || defaultNext);
            }
          });
        });
    }

    function regenerateHero() {
      if (state.regenCount >= 5) {
        showError({
          title: 'Has llegado al límite de regeneraciones',
          body: 'Has regenerado varias veces esta vista previa. Sigue con el héroe actual o empieza de nuevo con otra foto.',
          reason: 'regen_limit',
          retry: function () {
            hideError();
          }
        });
        return;
      }

      var apiUrl = getHeroApiUrl();
      track('preview_hero_regenerated', {
        regen_count: state.regenCount + 1,
        has_hero_api: !!apiUrl
      });

      if (!apiUrl) {
        state.heroIndex = (state.heroIndex + 1) % Math.max(DEMO_HEROES.length, 1);
        state.heroUrl = '';
        renderStep();
        return;
      }

      state.regenCount += 1;
      if (state.step === 'see-cover') {
        startCoverJob();
        renderCoverPreview();
        return;
      }
      runGenerating('meet-hero');
    }

    function renderStep() {
      if (state.step === 'child-details') {
        syncNameUI();
      }
      if (state.step === 'child-meta') {
        syncMetaUI();
      }
      if (state.step === 'save-contact') {
        syncSaveContactUI();
      }
      if (state.step === 'meet-hero') {
        state.heroUrl = pickHero();
        var hero = root.querySelector('[data-hero-img]');
        var photo = root.querySelector('[data-hero-photo]');
        var nameOut = root.querySelector('[data-child-name-out]');
        if (hero) hero.src = state.heroUrl;
        if (photo && state.childFileUrl) photo.src = state.childFileUrl;
        if (nameOut) nameOut.textContent = state.childFirst || 'tu héroe';
      }
      if (state.step === 'see-cover') {
        if (!state.coverUrl && !state.coverPending && !state.coverFailed) startCoverJob();
        renderCoverPreview();
      }
      if (state.step === 'grandma-details') {
        var gthumb = root.querySelector('[data-grandma-thumb]');
        if (gthumb && state.grandmaFileUrl) gthumb.src = state.grandmaFileUrl;
      }
      if (state.step === 'book-preview') {
        renderBookPreview();
      }
    }

    function updateNameCoach() {
      if (!coachText) return;
      var first = ((root.querySelector('[data-child-first]') || {}).value || '').trim();
      var last = ((root.querySelector('[data-child-last]') || {}).value || '').trim();
      var full = [first, last].filter(Boolean).join(' ');
      if (full) {
        coachText.textContent = full + '. Revisa bien la ortografía para el libro.';
      } else {
        coachText.textContent = COACH['child-details'];
      }
    }

    function syncNameUI() {
      var firstInput = root.querySelector('[data-child-first]');
      var lastInput = root.querySelector('[data-child-last]');
      var cover = root.querySelector('[data-name-cover]');
      var coverValue = root.querySelector('[data-name-cover-value]');
      var hint = root.querySelector('[data-name-hint]');
      var btn = root.querySelector('[data-name-continue]');
      var label = root.querySelector('[data-name-continue-label]');

      var first = ((firstInput && firstInput.value) || '').trim();
      var last = ((lastInput && lastInput.value) || '').trim();
      var full = [first, last].filter(Boolean).join(' ');

      if (cover && coverValue) {
        if (full) {
          cover.hidden = false;
          coverValue.textContent = full;
          if (hint) hint.hidden = true;
        } else {
          cover.hidden = true;
          coverValue.textContent = '';
          if (hint) hint.hidden = false;
        }
      }

      if (btn) btn.disabled = !first;
      if (label) {
        if (first) {
          label.innerHTML = 'Confirmar nombre <span aria-hidden="true">→</span>';
        } else {
          label.innerHTML = "Escribe el nombre del héroe <span aria-hidden=\"true\">↑</span>";
        }
      }

      updateNameCoach();
    }

    // The composed cover is a local data URI; state.coverUrl stays the fal
    // reference we report to analytics and the cart.
    function coverDisplayUrl() {
      return state.coverImage || state.coverUrl || '';
    }

    function renderCoverPreview() {
      var img = root.querySelector('[data-cover-img]');
      var nameEl = root.querySelector('[data-cover-child-name]');
      var loading = root.querySelector('[data-cover-loading]');
      var stage = root.querySelector('[data-cover-stage]');
      var ready = !!coverDisplayUrl() && !state.coverPending;
      if (img) {
        if (ready) img.src = coverDisplayUrl();
        img.hidden = !ready;
      }
      if (stage) stage.setAttribute('data-state', ready ? 'ready' : state.coverFailed ? 'failed' : 'loading');
      if (loading) {
        loading.hidden = ready;
        var loadingText = loading.querySelector('[data-cover-loading-text]') || loading;
        loadingText.textContent = state.coverFailed
          ? 'No hemos podido personalizar la portada. Pulsa Regenerar.'
          : 'Personalizando el libro, te mostramos la portada…';
      }
      if (nameEl) {
        var full = [state.childFirst, state.childLast].filter(Boolean).join(' ');
        nameEl.textContent = full ? ('El cuento de ' + full) : '';
        nameEl.hidden = !full || !ready;
      }
    }

    function renderBookPreview() {
      var cover = root.querySelector('[data-book-cover]');
      var badge = root.querySelector('[data-book-names]');
      var summary = root.querySelector('[data-wiz-summary]');
      if (cover) {
        cover.src = coverDisplayUrl() || coverUrl;
        if (cover.parentElement) {
          cover.parentElement.classList.toggle('is-personal-cover', !!coverDisplayUrl());
        }
      }

      var fullName = [state.childFirst, state.childLast].filter(Boolean).join(' ');
      var lines = [];
      if (fullName) lines.push('Protagonista: ' + fullName);
      if (state.includeGrandma && state.grandmaName) lines.push('Con ' + state.grandmaName);
      if (badge) badge.textContent = lines.join(' · ') || 'Tu libro personalizado';

      if (summary) {
        var genderLabel = state.childGender === 'girl' ? 'Niña' : state.childGender === 'boy' ? 'Niño' : '—';
        var items = [
          ['Peque', fullName || '—'],
          ['Edad', state.childAge || '—'],
          ['Género', genderLabel]
        ];
        if (hasGrandmaFlow) {
          items.push(['Abuela', state.includeGrandma ? (state.grandmaName || 'Incluida') : 'Sin añadir']);
          if (state.includeGrandma) items.push(['Extra abuela', '+4,99 €']);
        }
        summary.innerHTML = items.map(function (pair) {
          return '<li><span>' + pair[0] + '</span><span>' + escapeHtml(pair[1]) + '</span></li>';
        }).join('');
      }
    }

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function validateChildDetails() {
      var firstInput = root.querySelector('[data-child-first]');
      var first = (firstInput && firstInput.value || '').trim();
      root.querySelectorAll('.is-invalid').forEach(function (el) {
        el.classList.remove('is-invalid');
      });
      if (!first) {
        if (firstInput) {
          firstInput.classList.add('is-invalid');
          firstInput.focus();
        }
        syncNameUI();
        return false;
      }
      state.childFirst = first;
      state.childLast = ((root.querySelector('[data-child-last]') || {}).value || '').trim();
      return true;
    }

    function syncMetaUI() {
      var ageSlider = root.querySelector('[data-child-age-slider]');
      var ageHidden = root.querySelector('[data-child-age]');
      var ageValue = root.querySelector('[data-age-value]');
      var age = state.childAge || (ageSlider && ageSlider.value) || '4';
      if (ageSlider) ageSlider.value = age;
      if (ageHidden) ageHidden.value = age;
      if (ageValue) ageValue.textContent = age;

      root.querySelectorAll('[data-gender-pick]').forEach(function (btn) {
        var on = btn.getAttribute('data-gender-pick') === state.childGender;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
    }

    function isValidWhatsapp(value) {
      var digits = String(value || '').replace(/\D/g, '');
      return digits.length >= 8 && digits.length <= 15;
    }

    function syncSaveContactUI() {
      var fullName = [state.childFirst, state.childLast].filter(Boolean).join(' ') || 'Tu héroe';
      var chip = root.querySelector('[data-save-name-chip]');
      if (chip) chip.textContent = fullName;

      var first = state.childFirst || 'tu héroe';
      var sub = root.querySelector('[data-save-subcopy]');
      var method = state.contactMethod || 'email';

      root.querySelectorAll('[data-contact-method]').forEach(function (tab) {
        var on = tab.getAttribute('data-contact-method') === method;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      root.querySelectorAll('[data-contact-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-contact-panel') !== method;
      });

      if (sub) {
        if (method === 'whatsapp') {
          sub.textContent =
            "Introduce tu número de WhatsApp y te enviamos el avatar en alta resolución de " + first + ".";
        } else {
          sub.textContent =
            "Introduce tu correo y te enviamos el avatar en alta resolución de " + first + " a la bandeja de entrada.";
        }
      }

      var emailInput = root.querySelector('[data-contact-email]');
      var waInput = root.querySelector('[data-contact-whatsapp]');
      var emailField = emailInput && emailInput.closest('.ms-wiz-save-field');
      var waField = waInput && waInput.closest('.ms-wiz-save-field');
      var emailOk = root.querySelector('[data-email-ok]');
      var waOk = root.querySelector('[data-whatsapp-ok]');
      var btn = root.querySelector('[data-save-continue]');
      var label = root.querySelector('[data-save-continue-label]');

      if (emailInput && state.contactEmail) emailInput.value = state.contactEmail;
      if (waInput && state.contactWhatsapp) waInput.value = state.contactWhatsapp;

      var emailValid = isValidEmail(emailInput && emailInput.value);
      var waValid = isValidWhatsapp(waInput && waInput.value);

      if (emailField) emailField.classList.toggle('is-valid', emailValid);
      if (waField) waField.classList.toggle('is-valid', waValid);
      if (emailOk) emailOk.hidden = !emailValid;
      if (waOk) waOk.hidden = !waValid;

      var ready = method === 'whatsapp' ? waValid : emailValid;
      if (btn) btn.disabled = !ready;
      if (label) {
        label.innerHTML = ready
          ? 'Guardar avatar <span aria-hidden="true">→</span>'
          : method === 'whatsapp'
            ? 'Introduce el número de WhatsApp <span aria-hidden="true">↑</span>'
            : 'Introduce el correo electrónico <span aria-hidden="true">↑</span>';
      }
    }

    function continueAfterSave() {
      if (hasGrandmaFlow) go('add-grandma');
      else go('book-preview');
    }

    function readChildMeta() {
      var ageHidden = root.querySelector('[data-child-age]');
      var ageSlider = root.querySelector('[data-child-age-slider]');
      state.childAge = (ageHidden && ageHidden.value) || (ageSlider && ageSlider.value) || '4';
      if (!state.childGender || (state.childGender !== 'girl' && state.childGender !== 'boy')) {
        state.childGender = 'neutral';
      }
      return true;
    }

    function validateGrandmaDetails() {
      var nameInput = root.querySelector('[data-grandma-name]');
      var name = ((nameInput && nameInput.value) || '').trim();
      if (nameInput) nameInput.classList.remove('is-invalid');
      if (!name) {
        if (nameInput) {
          nameInput.classList.add('is-invalid');
          nameInput.focus();
        }
        showError({
          title: 'Necesitamos el nombre de la abuela',
          body: 'Dinos cómo la llamamos en el libro y pulsa Reintentar para continuar.',
          retry: function () {
            hideError();
            if (nameInput) nameInput.focus();
          }
        });
        return false;
      }
      state.grandmaName = name;
      return true;
    }

    function addToCart() {
      var props = {
        '_preview_shell': 'true',
        'Child first name': state.childFirst,
        'Child last name': state.childLast || '',
        'Child age': state.childAge || '',
        'Child gender': state.childGender || '',
        'Book': root.getAttribute('data-product-title') || ''
      };
      if (state.heroUrl) props['Hero image URL'] = state.heroUrl;
      if (state.coverUrl) props['Cover preview URL'] = state.coverUrl;
      if (state.originalPhotoUrl) props['Child photo URL'] = state.originalPhotoUrl;
      if (state.grandmaPhotoUrl) props['Grandma photo URL'] = state.grandmaPhotoUrl;
      if (state.archiveKey) props['_funnel_photo_key'] = state.archiveKey;
      if (state.grandmaArchiveKey) props['_grandma_photo_key'] = state.grandmaArchiveKey;
      if (state.heroSeed != null) props['Hero seed'] = String(state.heroSeed);
      if (state.heroRequestId) props['Hero generation id'] = state.heroRequestId;
      if (state.contactSaved) {
        props['Contact method'] = state.contactMethod || 'email';
        if (state.contactMethod === 'whatsapp' && state.contactWhatsapp) {
          props['WhatsApp'] = state.contactWhatsapp;
        }
        if (state.contactEmail) props['Email'] = state.contactEmail;
      }
      if (hasGrandmaFlow) {
        props['Include grandma'] = state.includeGrandma ? 'Yes (+4,99 €)' : 'No';
        if (state.includeGrandma) props['Nombre de la abuela'] = state.grandmaName || '';
      }

      track('preview_add_to_cart_clicked', {
        include_grandma: !!state.includeGrandma,
        child_age: state.childAge || null,
        child_gender: state.childGender || null
      });

      var btn = root.querySelector('[data-wiz-addtocart]');
      var label = btn && btn.querySelector('.ms-wiz-btn__label');
      if (btn) {
        btn.disabled = true;
        if (label) label.textContent = 'Añadiendo…';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: Number(getVariantId()),
          quantity: 1,
          properties: props
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Error al añadir a la cesta');
          return r.json();
        })
        .then(function () {
          archivePreview({ skipPhoto: true, status: 'ordered' });
          track('preview_add_to_cart_success', {
            include_grandma: !!state.includeGrandma,
            funnel_elapsed_ms: funnelStartedAt ? Date.now() - funnelStartedAt : null
          });
          window.location.href = '/cart';
        })
        .catch(function () {
          track('preview_add_to_cart_failed');
          if (btn) {
            btn.disabled = false;
            if (label) label.textContent = 'Añadir a la cesta — Continuar';
          }
          showError({
            reason: 'add_to_cart_failed',
            retry: function () {
              hideError();
              addToCart();
            }
          });
        });
    }

    // Events
    openers.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var source = el.getAttribute('data-ph-source') || el.getAttribute('data-open-preview') || 'preview_cta';
        track('preview_cta_clicked', {
          source: source,
          cta_text: (el.textContent || '').trim().slice(0, 80),
          cta_tag: el.tagName
        });
        open(source);
      });
    });

    root.querySelectorAll('[data-wiz-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        close(el.classList.contains('ms-wiz__backdrop') ? 'backdrop' : 'close_button');
      });
    });

    if (backBtn) backBtn.addEventListener('click', function () {
      track('preview_back_clicked', { from_step: state.step });
      // custom back logic
      if (state.step === 'meet-hero') return go('child-meta', { replace: true });
      if (state.step === 'see-cover') return go('meet-hero', { replace: true });
      if (state.step === 'save-contact') {
        if (isDinoBook()) return go('see-cover', { replace: true });
        return go('meet-hero', { replace: true });
      }
      if (state.step === 'add-grandma') return go('save-contact', { replace: true });
      if (state.step === 'upload-grandma') return go('add-grandma', { replace: true });
      if (state.step === 'grandma-details') return go('upload-grandma', { replace: true });
      if (state.step === 'book-preview') {
        if (hasGrandmaFlow && state.includeGrandma) return go('grandma-details', { replace: true });
        if (hasGrandmaFlow) return go('add-grandma', { replace: true });
        return go('save-contact', { replace: true });
      }
      if (state.step === 'child-meta') return go('child-details', { replace: true });
      if (state.step === 'child-details') return go('upload-child', { replace: true });
      close('back');
    });

    var childFile = root.querySelector('[data-child-file]');
    if (childFile) {
      childFile.addEventListener('click', function () {
        track('preview_photo_picker_opened', { photo_kind: 'child' });
      });
      childFile.addEventListener('change', function () {
        var file = childFile.files && childFile.files[0];
        if (!file) return;
        handlePhotoSelect(file, 'child');
        setTimeout(function () {
          try { childFile.value = ''; } catch (e) {}
        }, 0);
      });
    }

    var grandmaFile = root.querySelector('[data-grandma-file]');
    if (grandmaFile) {
      grandmaFile.addEventListener('click', function () {
        track('preview_photo_picker_opened', { photo_kind: 'grandma' });
      });
      grandmaFile.addEventListener('change', function () {
        var file = grandmaFile.files && grandmaFile.files[0];
        if (!file) return;
        handlePhotoSelect(file, 'grandma');
        setTimeout(function () {
          try { grandmaFile.value = ''; } catch (e) {}
        }, 0);
      });
    }

    var childFirstInput = root.querySelector('[data-child-first]');
    var childLastInput = root.querySelector('[data-child-last]');
    if (childFirstInput) {
      childFirstInput.addEventListener('input', syncNameUI);
      childFirstInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var btn = root.querySelector('[data-name-continue]');
          if (btn && !btn.disabled) btn.click();
        }
      });
    }
    if (childLastInput) {
      childLastInput.addEventListener('input', syncNameUI);
      childLastInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var btn = root.querySelector('[data-name-continue]');
          if (btn && !btn.disabled) btn.click();
        }
      });
    }

    root.querySelectorAll('[data-gender-pick]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.childGender = btn.getAttribute('data-gender-pick') || 'neutral';
        syncMetaUI();
        track('preview_gender_selected', { child_gender: state.childGender });
      });
    });

    var ageSlider = root.querySelector('[data-child-age-slider]');
    var ageHidden = root.querySelector('[data-child-age]');
    var ageValue = root.querySelector('[data-age-value]');
    if (ageSlider) {
      ageSlider.addEventListener('input', function () {
        var v = ageSlider.value;
        state.childAge = v;
        if (ageHidden) ageHidden.value = v;
        if (ageValue) ageValue.textContent = v;
      });
      ageSlider.addEventListener('change', function () {
        track('preview_age_selected', { child_age: ageSlider.value });
      });
    }

    // Default age
    state.childAge = state.childAge || '4';

    root.querySelectorAll('[data-wiz-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        track('preview_continue_clicked', { from_step: state.step });
        if (state.step === 'child-details') {
          if (!validateChildDetails()) {
            track('preview_child_details_invalid');
            return;
          }
          track('preview_child_details_submitted', {
            has_last_name: !!state.childLast
          });
          archivePreview({ skipPhoto: true, status: 'preview' });
          if (state.editingNameFromSave) {
            state.editingNameFromSave = false;
            go('save-contact');
            return;
          }
          go('child-meta');
          return;
        }
        if (state.step === 'child-meta') {
          readChildMeta();
          track('preview_child_meta_submitted', {
            child_age: state.childAge || null,
            child_gender: state.childGender || null
          });
          archivePreview({ skipPhoto: true, status: 'generating' });
          runGenerating();
          return;
        }
        if (state.step === 'meet-hero') {
          track('preview_hero_accepted', { hero_index: state.heroIndex });
          go(isDinoBook() ? 'see-cover' : 'save-contact');
          return;
        }
        if (state.step === 'see-cover') {
          track('preview_cover_accepted', { has_cover: !!state.coverUrl });
          go('save-contact');
          return;
        }
        if (state.step === 'save-contact') {
          var method = state.contactMethod || 'email';
          var emailInput = root.querySelector('[data-contact-email]');
          var waInput = root.querySelector('[data-contact-whatsapp]');
          state.contactEmail = ((emailInput && emailInput.value) || '').trim();
          state.contactWhatsapp = ((waInput && waInput.value) || '').trim();
          if (method === 'email' && !isValidEmail(state.contactEmail)) {
            syncSaveContactUI();
            return;
          }
          if (method === 'whatsapp' && !isValidWhatsapp(state.contactWhatsapp)) {
            syncSaveContactUI();
            return;
          }
          state.contactSaved = true;
          track('preview_contact_saved', {
            contact_method: method,
            has_email: !!state.contactEmail,
            has_whatsapp: !!state.contactWhatsapp
          });
          archivePreview({ skipPhoto: true, status: 'contacted' });
          continueAfterSave();
          return;
        }
        if (state.step === 'grandma-details') {
          if (!validateGrandmaDetails()) {
            track('preview_grandma_details_invalid');
            return;
          }
          track('preview_grandma_details_submitted');
          go('book-preview');
        }
      });
    });

    root.querySelectorAll('[data-contact-method]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        state.contactMethod = tab.getAttribute('data-contact-method') || 'email';
        syncSaveContactUI();
        track('preview_contact_method_selected', { contact_method: state.contactMethod });
      });
    });

    var emailInputEl = root.querySelector('[data-contact-email]');
    var waInputEl = root.querySelector('[data-contact-whatsapp]');
    if (emailInputEl) {
      emailInputEl.addEventListener('input', function () {
        state.contactEmail = emailInputEl.value;
        syncSaveContactUI();
      });
    }
    if (waInputEl) {
      waInputEl.addEventListener('input', function () {
        state.contactWhatsapp = waInputEl.value;
        syncSaveContactUI();
      });
    }

    var editNameBtn = root.querySelector('[data-edit-name]');
    if (editNameBtn) {
      editNameBtn.addEventListener('click', function () {
        state.editingNameFromSave = true;
        track('preview_edit_name_clicked');
        go('child-details');
      });
    }

    var saveSkip = root.querySelector('[data-save-skip]');
    if (saveSkip) {
      saveSkip.addEventListener('click', function () {
        track('preview_contact_skipped');
        continueAfterSave();
      });
    }

    root.querySelectorAll('[data-wiz-regen]').forEach(function (regen) {
      regen.addEventListener('click', function () {
        regenerateHero();
      });
    });

    root.querySelectorAll('[data-wiz-restart]').forEach(function (restart) {
      restart.addEventListener('click', function () {
        track('preview_funnel_restarted', { from_step: state.step });
        go('upload-child', { replace: true });
      });
    });

    var grandmaYes = root.querySelector('[data-grandma-yes]');
    if (grandmaYes) {
      grandmaYes.addEventListener('click', function () {
        state.includeGrandma = true;
        track('preview_grandma_chose_yes');
        go('upload-grandma');
      });
    }

    var grandmaSkip = root.querySelector('[data-grandma-skip]');
    if (grandmaSkip) {
      grandmaSkip.addEventListener('click', function () {
        state.includeGrandma = false;
        state.grandmaName = '';
        track('preview_grandma_skipped');
        go('book-preview');
      });
    }

    root.querySelectorAll('[data-page-src]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-page-src');
        var cover = root.querySelector('[data-book-cover]');
        root.querySelectorAll('[data-page-src]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        if (cover && src) cover.src = src;
        track('preview_book_page_selected', {
          page_index: Array.prototype.indexOf.call(
            root.querySelectorAll('[data-page-src]'),
            btn
          )
        });
      });
    });

    var addBtn = root.querySelector('[data-wiz-addtocart]');
    if (addBtn) addBtn.addEventListener('click', addToCart);

    if (errorRetry) {
      errorRetry.addEventListener('click', function () {
        track('preview_error_retry_clicked', { wizard_step: state.step });
        var fn = retryFn;
        hideError();
        if (fn) fn();
      });
    }

    if (photoBannerClose) {
      photoBannerClose.addEventListener('click', function () {
        track('preview_photo_banner_dismissed');
        hidePhotoBanner();
      });
    }

    // Demo: ?ms_wiz_error=1 shows the error card
    if (/[?&]ms_wiz_error=1(?:&|$)/.test(window.location.search)) {
      open('demo_error');
      go('child-details', { replace: true });
      showError({
        reason: 'demo',
        retry: function () {
          hideError();
        }
      });
    }

    // Demo: ?ms_wiz_photo=1 shows the photo requirements tip on upload
    if (/[?&]ms_wiz_photo=1(?:&|$)/.test(window.location.search)) {
      open('demo_photo');
      showPhotoBanner({
        format: true,
        maxSize: true,
        minRes: false,
        maxRes: true,
        ok: false,
        canProceed: true
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) {
        if (errorEl && !errorEl.hidden) {
          hideError();
          return;
        }
        close('escape');
      }
    });
  });
})();
